import { render } from "./MovieScrollerList.vue?vue&type=template&id=433a23a4"
import script from "./MovieScrollerList.vue?vue&type=script&lang=js"
export * from "./MovieScrollerList.vue?vue&type=script&lang=js"

import "./MovieScrollerList.vue?vue&type=style&index=0&id=433a23a4&lang=css"
script.render = render

export default script